import React from "react";
import { motion } from "framer-motion";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import "./About.scss";

function About() {
  return (
    <div>
      <div id="about" className="about_section">
        <div className="about_container">
          <motion.h3
            whileInView={{ y: [-20, 0], opacity: [0, 1] }}
            transition={{ duration: 0.7 }}
            className="about_header"
          >
            About Me
          </motion.h3>
          <motion.p
            whileInView={{ y: [20, 0], opacity: [0, 1] }}
            transition={{ duration: 0.7 }}
            className="about_details"
          >
            Dynamic Software Engineer and JavaScript Expert, skilled at
            developing complex solutions. Offering 3+ years of hands-on
            experience in professional design and development of web
            applications using a range of technologies and programming
            languages. Seeking to leverage broad development experience and
            technical expertise in a challenging role as a Software Engineer.
            Recognized as a resource person, problem solver and team player
          </motion.p>
          <motion.div
            whileInView={{ y: [20, 0], opacity: [0, 1] }}
            transition={{ duration: 0.7 }}
            className="about_socials"
          >
            <a
              href="https://www.linkedin.com/in/chukwuemekankwo/"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://github.com/EmekaNkwo"
              target="_blank"
              rel="noreferrer"
            >
              <FaGithub />
            </a>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default About;
